import Joi, { ValidationResult } from 'joi';

type DiscountValidationInput = {
    discountPrice: string;
    startDate: string;
    endDate: string;
};

type DiscountValidationItem = {
    discountPrice: number;
    startDate: string;
    endDate: string;
    endDateCopy: string;
};

const discountErrorSchema = Joi.object()
    .options({ abortEarly: false })
    .keys({
        discountPrice: Joi.number().positive().required().messages({
            'number.base': 'Discount price must be greater than 0.',
            'number.positive': 'Discount price must be greater than 0.',
            'any.required': 'Discount price must be greater than 0.',
        }),
        startDate: Joi.date().required().less(Joi.ref('endDateCopy')).messages({
            'date.base': 'Start date must be selected.',
            'date.less': 'Start date must be before end date.',
            'any.required': 'Start date must be selected.',
        }),
        endDate: Joi.date().required().greater(Joi.ref('startDate')).messages({
            'date.base': 'End date must be selected.',
            'date.greater': 'End date must be after start date.',
            'any.required': 'End date must be selected.',
        }),
        endDateCopy: Joi.any(),
    });

function validateDiscount(item: DiscountValidationInput): ValidationResult {
    const validationItem: DiscountValidationItem = {
        discountPrice: Number(item.discountPrice),
        startDate: item.startDate,
        endDate: item.endDate,
        endDateCopy: item.endDate,
    };

    return discountErrorSchema.validate(validationItem);
}

export default validateDiscount;
